import Qty from "js-quantities";
import { CropConversions } from "./lib/crops/crops.models";

/**
 * Returns the crop conversion source data
 *
 * This function is used to compare new crop data with what the library
 * already has.
 *
 * @returns CropConversions data
 */
export const getConversionData = async (): Promise<CropConversions> => {
  const { CROP_CONVERSIONS } = await import("./lib/crops/conversionData");
  return CROP_CONVERSIONS;
};

export type { toLocaleDisplayUnits } from "./lib/crops/conversionFunctions";

export default Qty;
